module.exports = __webpack_public_path__ + "img/globe.c1a7a0b.png";